"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var VideoManager = /** @class */ (function () {
    function VideoManager() {
        this.controlledVideos = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_HAS_CONTROLS, "]"));
        this.autoplayVideos = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_AUTOPLAY, "]"));
        if (!this.controlledVideos.length && !this.autoplayVideos.length) {
            return;
        }
        this.handleManualPlayVideos();
        this.setupPreloadObserver();
        this.setupPlayObserver();
    }
    // Ensures only one manually controlled video plays at a time
    VideoManager.prototype.handleManualPlayVideos = function () {
        var _this = this;
        this.controlledVideos.forEach(function (video) {
            video.addEventListener('play', function () {
                _this.controlledVideos.forEach(function (otherVideo) {
                    if (video !== otherVideo) {
                        otherVideo.pause();
                    }
                });
            });
        });
    };
    // First Observer: Preloads video before it enters the viewport
    VideoManager.prototype.setupPreloadObserver = function () {
        var _this = this;
        this.preloadObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var video = entry.target;
                var source = video.querySelector('source');
                if (entry.isIntersecting && !video.src) {
                    // Load the video source before it fully enters the viewport
                    if (source && source.hasAttribute('data-src')) {
                        source.setAttribute('src', source.getAttribute('data-src'));
                        source.removeAttribute('data-src');
                        video.load();
                    }
                    // Stop observing once preloaded (to avoid redundant checks)
                    _this.preloadObserver.unobserve(video);
                }
            });
        }, {
            root: null,
            rootMargin: '0% 20% 20% 0%', // Preload when video is 20% away from the bottom or the right (for storytelling element) side of the viewport
        });
        this.autoplayVideos.forEach(function (video) { return _this.preloadObserver.observe(video); });
    };
    // Second Observer: Plays video when visible & pauses when out of viewport
    VideoManager.prototype.setupPlayObserver = function () {
        var _this = this;
        this.playObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var video = entry.target;
                var isAutoplay = video.hasAttribute(constants_1.DATA_VIDEO_AUTOPLAY);
                if (entry.isIntersecting) {
                    // Only autoplay videos should resume playing
                    if (isAutoplay && video.paused) {
                        video.play();
                    }
                }
                else {
                    // Pause both autoplay and controlled videos when out of viewport
                    if (video.currentTime > 0 && !video.paused && !video.ended) {
                        video.pause();
                    }
                }
            });
        }, {
            root: null,
            threshold: 0.33, // Only play and pause when at least 1/3 of the video is visible
        });
        // Convert NodeLists to arrays before using .forEach()
        Array.from(this.controlledVideos).concat(Array.from(this.autoplayVideos)).forEach(function (video) { return _this.playObserver.observe(video); });
    };
    return VideoManager;
}());
exports.default = VideoManager;
